import Vue from 'vue'

Vue.directive('comma', {
  bind: (el, binding, vnode) => {
    let handler = function (e) {
      if (e.target.tagName === 'INPUT') {
        e.target.value = e.target.value.replace(/,/g, '.')
        vnode.elm.dispatchEvent(new Event('input'))
      }
    }

    el.addEventListener('input', handler)
  }
})
